<script>
import Actions from "./Actions.vue";

export default {
    components: {
        Actions,
    },
    data() {
        return {};
    },

    methods: {
        goWithTheFlow(goFlow) {
            // if simple
            if (goFlow === "advanced") {
                this.$router.push({ name: "Advanced Add Course" });
            } else if (goFlow === "simple") {
                this.$router.push({ name: "Add venue" });
            }
            // else
        },
        prevStep() {
            window.location.href = "/register/create";
        },
        nextStep() {
            alert("Please select an option above.");
        },
    },
};
</script>

<template>

    <div id="funnel-page-container" class="new-listing-advanced-flow">

        <div id="funnel-page-main-tile">

            <div class="row">
                <div class="col-md-12">
                    <h2>Event creation</h2>
                    <div class="lg-grey-txt">Please select the most suitable option.</div>
                </div>
            </div>

            <div class="funnel-choices row no-gutters" id="first-one"
                 @click="goWithTheFlow('simple')"
                 data-test="link-create-simple-activity">

                <div class="icon-gap">
                    <div class="center-event-icon">
                        <img src="/images/add-events/add-simple-event.png"/>
                    </div>
                </div>
                <div class="col-md-10">
                    <span class="ul-header">
                        Simple event creation
                    </span>
                    <ul class="lg-grey-txt ul-lp">
                        <li>For smaller organisers with 1-10 events or courses</li>
                        <li>Full flexibility to create one-off or recurring events</li>
                        <li>Quick, straightforward and easy</li>
                    </ul>
                </div>

            </div>

            <div class="funnel-choices row no-gutters"
                 @click="goWithTheFlow('advanced')"
                 data-test="link-create-advanced-activity">

                <div class="icon-gap">
                    <div class="center-event-icon">
                        <img src="/images/add-events/add-adv-event.png"/>
                    </div>
                </div>
                <div class="col-md-10">
                    <span class="ul-header">
                        Advanced event creation
                    </span>
                    <ul class="lg-grey-txt ul-lp">
                        <li>For larger organisers with 10+ events or courses</li>
                        <li>Add daily/weekly events within a fixed date range e.g. Autumn term or half term</li>
                        <li>Great for organisations that work around school terms or holiday camps</li>
                    </ul>
                </div>

            </div>

        </div>

    </div>

    <Actions
        @prev="prevStep"
        @next="nextStep"
        class="fixed-bottom"
        :disabled="false"
        :full-width="true"
        actions-styles="alt-bottom-actions"
        additional-block-class="pages-menu"
    />

</template>

<style scoped>
.icon-gap {
    margin: 0 24px;
}

#funnel-page-container {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}

#funnel-page-main-tile {
    max-width: 703px;
    background-color: white;
    margin-left: auto;
    margin-right: auto;
    background-color: white;

    margin-top: 20px;
    margin-bottom: 20px;

    padding: 20px;
}

#funnel-page-main-tile #first-one {
    margin-top: 48px;
}

.new-listing-advanced-flow .ul-lp {
    padding-left: 23px;
    margin-top: 8px;
}

.funnel-choices {
    min-width: 700px;
}

@media only screen and (max-width: 768px) {
    .funnel-choices {
        min-width: 100%;
        padding: 15px
    }
}

.funnel-choices.row {

    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    border-radius: 15px;
    margin-bottom: 27px;

    cursor: pointer;
}

.center-event-icon {

    display: flex;
    height: 100%;
    align-items: center; /* vertically */
    justify-content: center; /* horizontally */

}

#funnel-page-main-tile .funnel-choices.row .col-md-10 {
    padding-top: 24px;
    padding-top: 24px;
}
</style>
